export const en = {
    delete_companion: 'Remove companion',
    not_found_error_title: 'The profile does not exist or you do not have access',
    not_found_error_description: 'To get access, contact the coordinator',
    to_the_main_action: 'To the main page',
};
